/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import { Modal } from 'antd-mobile'
import { AdvDialogStyle } from '@styles/modal'
import { isMobile } from 'react-device-detect'
import { GlobalStoreKey } from '@v2/constants/common'
import useRootStore from '@store/useRootStore'
// img
import VideoFrameImg from '@assets/images/bg/video-frame.png'
import EventGuideImg from '@assets/images/banner/tutorial-video/user-pick-benefit-detail-banner.jpg'
import NewUserEventBannerImg from '@assets/images/banner/tutorial-video/new-user-event-banner.png'
// css
import { ModalBg } from '@styles/base.style'
import { Button, XIcoBtn } from '@styles/button.style'
import { TutorialVideoWrap } from './index.style'

const TutorialVideoPopup: React.FC = () => {
  const { globalStore, logStore } = useRootStore()
  const { visibleTutorialVideoPopup } = globalStore
  const videoUrl = globalStore.findGlobalSetting(GlobalStoreKey.TUTORIAL_VIDEO_URL)?.value ?? 'https://www.youtube.com/embed/bcrCjRTvCtk'

  const onCloseModal = () => {
    logStore.writeButtonLog({ pageId: 'd070', buttonId: '001' }).catch(console.error)
    globalStore.setVisibleTutorialVideoPopup(false)
  }

  const EventGuideImgPopup = () => {
    return (
      <img src={EventGuideImg} alt="신규가입자를 위한 무료머니 이벤트 안내 이미지" style={{ width: '100%' }} loading="lazy"/>
    )
  }

  const onClickEventGuidePopup = () => {
    logStore.writeButtonLog({ pageId: 'd070', buttonId: '002' }).catch(console.error)
    globalStore.addGeneralPopupProperties(<EventGuideImgPopup/>, '무료머니 이벤트 안내', {
      wrapClassName: '',
      className: 'adv-event',
      isScroll: true,
      custom: false,
      clsBtn: false,
    })
  }

  return (
    <Modal
      visible={visibleTutorialVideoPopup}
      transparent
      maskClosable={false}
      onClose={onCloseModal}
      className="event"
      css={AdvDialogStyle}
    >
      <TutorialVideoWrap className={!isMobile && 'pc-tutorial-video-wrap'}>
        <Button TP css={XIcoBtn} className="circle" onClick={onCloseModal}>
          <span className="x-ico"/>
        </Button>
        <div className="video-wrap">
          <img src={VideoFrameImg} alt="" className="frame-img"/>
          <iframe
            width="1280"
            height="720"
            src={videoUrl} title="5분만에 승부사온라인 찐고수되기!"
            style={{ border: 0 }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>

        <Button TP onClick={onClickEventGuidePopup} className="event-guide-btn">
          <img src={NewUserEventBannerImg} alt="신규가입자를 위한 무료머니 모으는 법 5" className="event-guide-banner"  loading="lazy"/>
        </Button>
      </TutorialVideoWrap>

      <ModalBg className="dialog-bg"/>
    </Modal>
  )
}

export default observer(TutorialVideoPopup)
